import { defineComponent as _defineComponent } from 'vue'
import Cleave from "vue-cleave-component";
  import { reactive, computed, onMounted, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import {
    LandownerDetailsInterface,
    UserInterface,
  } from "@/types/UserInterface";
  import { validPhoneNumber } from "@/helpers/validation";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { UserRoles } from "@/enums/UserRoles";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandownerProfileUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const user = ref<UserInterface | null>(null);
  const userForm = reactive<Partial<UserInterface>>({
    firstName: "",
    lastName: "",
    phone: "",
  });
  const userDataCopy = {
    firstName: "",
    lastName: "",
  };
  const detailsForm = reactive<Partial<LandownerDetailsInterface>>({
    abnAcn: "",
    companyName: "",
    companyAddress: "",
  });
  const loading = ref(false);

  const isSalesPersonRole = computed(() => {
    return store.state.user.data.role === UserRoles.SALES_PERSON;
  });

  const isLandownerRole = computed(() => {
    return store.state.user.data.role === UserRoles.LANDOWNER;
  });

  const rules = computed(() => {
    if (isLandownerRole.value) {
      return {
        userForm: {
          firstName: { required, $autoDirty: true },
          lastName: { required, $autoDirty: true },
          phone: { validPhoneNumber, $autoDirty: true },
        },
        detailsForm: {
          abnAcn: { required, $autoDirty: true },
          companyName: { required, $autoDirty: true },
          companyAddress: { required, $autoDirty: true },
        },
      };
    }

    return {
      userForm: {
        firstName: { required, $autoDirty: true },
        lastName: { required, $autoDirty: true },
        phone: { validPhoneNumber, $autoDirty: true },
      },
    };
  });
  const v$ = useVuelidate(rules, { userForm, detailsForm });

  onMounted(() => {
    getUser();
  });

  const getUser = () => {
    loading.value = true;
    store
      .dispatch("user/getUser", store.state.user.data._id)
      .then((res) => {
        user.value = res.data;
        userForm.firstName = res.data.firstName;
        userForm.lastName = res.data.lastName;
        userForm.phone = res.data.phone;
        userDataCopy.firstName = res.data.firstName;
        userDataCopy.lastName = res.data.lastName;

        if (isLandownerRole.value) {
          detailsForm.abnAcn = res.data.detailsId.abnAcn;
          detailsForm.companyName = res.data.detailsId.companyName;
          detailsForm.companyAddress = res.data.detailsId.companyAddress;
        }
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const updateUser = async () => {
    loading.value = true;
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    const userData = {
      id: user.value?._id,
      data: userForm,
    };
    const detailsData = {
      id: (user.value?.detailsId as LandownerDetailsInterface)._id,
      data: detailsForm,
    };

    if (isSalesPersonRole.value) {
      userForm.email = user.value?.email;
    }

    Promise.all([
      store.dispatch("user/updateUser", userData),
      isLandownerRole.value
        ? store.dispatch("user/updateLandownerDetails", detailsData)
        : store.dispatch("user/updateSalesPersonProfile", userForm),
    ])
      .then(async () => {
        await updateTokens();
        router.push({
          name: "LandownerProfile",
        });
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const updateTokens = () => {
    if (
      userForm.firstName !== userDataCopy.firstName ||
      userForm.lastName !== userDataCopy.lastName
    ) {
      return store.dispatch("user/updateTokens");
    }

    return null;
  };

const __returned__ = { user, userForm, userDataCopy, detailsForm, loading, isSalesPersonRole, isLandownerRole, rules, v$, getUser, updateUser, updateTokens, get Cleave() { return Cleave }, reactive, computed, onMounted, ref, get useVuelidate() { return useVuelidate }, get required() { return required }, get store() { return store }, get router() { return router }, get LandownerDetailsInterface() { return LandownerDetailsInterface }, get UserInterface() { return UserInterface }, get validPhoneNumber() { return validPhoneNumber }, get phoneNumberOption() { return phoneNumberOption }, get UserRoles() { return UserRoles } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})